import providerWrapper from "./providerWrapper"
import './src/styles/bootstrap.min.css'
import "animate.css/animate.min.css";
import './src/styles/shadow.css'
import './src/styles/base.css'

export const wrapRootElement = providerWrapper